import { type EmailSendSessionPeopleTypes } from "enums/emailSendSessionPeopleTypes";
import { type FileLike } from "interfaces";
import { FilterType, type FilterTypesMap } from "utils/filterUtils";
import type ScheduleTypes from "enums/scheduleTypes";
import { type PriorityLevels } from "enums";

export interface RemedialTrainingPayload {
  triggerTypeId: number | null;
  flowId: number | null;
  priority: PriorityLevels | null;
  dueDate: string | null;
  daysToComplete: number | null;
}

export interface CampaignPayload {
  id?: number;
  name: string;
  campaignTypeId?: number;
  subDomainId?: number;
  labels: string[];
  remedialTraining: RemedialTrainingPayload | null;
}

export interface EmailTemplatePayload {
  id?: number;
  subject: string;
  previewText: string;
  senderName: string;
  senderEmail: string;
  html: string;
  contentUrlWithSas: string;
}

export interface EmailTemplateRequest {
  id: number;
  subject: string;
  previewText: string;
  senderName: string;
  senderEmail: string;
}

export interface LandingPagePayload {
  id?: number;
  html: string;
  contentUrlWithSas: string;
}

export interface FeedbackPagePayload {
  id?: number;
  videoUrl: string;
  uploadedVideos: FileLike[];
  message: string;
}

export interface CreateCampaignRunPayload {
  runNow: boolean;
  isTest: boolean;
  peopleIds: { id: number; type: EmailSendSessionPeopleTypes }[];
  timeZone?: string | null;
  startDateTime?: string;
  packIds?: number[];
}

export interface FeedbackPageRequest {
  id: number;
  videoUrl: string;
  videoName: string;
  videoSize?: number;
  message: string;
}

export enum CampaignFiltersEnum {
  Tags = "tags",
  Labels = "labels",
  Packs = "packIds",
  Publishers = "publisherIds",
  DateCreated = "dateCreated",
  DateModified = "dateModified",
}

export const campaignFilterTypes: FilterTypesMap<CampaignFiltersEnum> = {
  dateCreated: FilterType.DateRange,
  dateModified: FilterType.DateRange,
  labels: FilterType.Array,
  packIds: FilterType.Array,
  publisherIds: FilterType.Array,
  tags: FilterType.Array,
};

export interface ScheduleConfiguration {
  type: ScheduleTypes;
  date: string;
  time: string;
  timeZone: string | null;
}
